module.exports = __webpack_public_path__ + "img/dead-face.c61e4448.png";